import { ReportingWidget } from '../../Reporting/components/ReportingWidget/ReportingWidget';

export const AdminSupportStats = ({ stats }) => {
  return (
    <ReportingWidget className="u-margin--large">
      <ReportingWidget.Tile>
        <ReportingWidget.Badge>Total Checks</ReportingWidget.Badge>
        <ReportingWidget.Value>{stats?.total_checks}</ReportingWidget.Value>
        <ReportingWidget.Label></ReportingWidget.Label>
      </ReportingWidget.Tile>
      <ReportingWidget.Tile>
        <ReportingWidget.Badge>Assigned in last 24h</ReportingWidget.Badge>
        <ReportingWidget.Value>{stats?.assigned_last_24h}</ReportingWidget.Value>
        <ReportingWidget.Label></ReportingWidget.Label>
      </ReportingWidget.Tile>
      <ReportingWidget.Tile>
        <ReportingWidget.Badge>In Progress</ReportingWidget.Badge>
        <ReportingWidget.Value>{stats?.in_progress}</ReportingWidget.Value>
        <ReportingWidget.Label></ReportingWidget.Label>
      </ReportingWidget.Tile>
      <ReportingWidget.Tile type={ReportingWidget.Types.InProgress}>
        <ReportingWidget.Badge>
          Submitted (
          {stats.total_checks == 0 ? 0 : Math.round((stats?.submitted * 100) / stats.total_checks)}
          %)
        </ReportingWidget.Badge>
        <ReportingWidget.Value>{stats?.submitted}</ReportingWidget.Value>
        <ReportingWidget.Label>Checks</ReportingWidget.Label>
      </ReportingWidget.Tile>
      <ReportingWidget.Tile type={ReportingWidget.Types.Warning}>
        <ReportingWidget.Badge>
          Overdue (
          {stats.total_checks == 0 ? 0 : Math.round((stats?.overdue * 100) / stats.total_checks)}
          %)
        </ReportingWidget.Badge>
        <ReportingWidget.Value>{stats?.overdue}</ReportingWidget.Value>
        <ReportingWidget.Label>Checks</ReportingWidget.Label>
      </ReportingWidget.Tile>
    </ReportingWidget>
  );
};
